<template>
    <div class="row">
        <help-modal></help-modal>
        <div class="col-xl-12">
            <div class="ibox form">
                <div class="ibox-title ibox-grey">
                    <h4>{{ __('analyze_parameters') }}</h4>
                    <div class="ibox-tools">
                        <button-open-help-modal :in-extra-div="false" :helpName="analyzeType == 'sell'? 'ASA-003' : 'ASB-003'"/>
                    </div>
                </div>

                <div class="ibox-content">
                    <div class="row">
                        <div class="col-2">
                            {{__('divide_into_groups_by')}}
                        </div>
                        <div class="col-2">
                            <select2 style="width: 90%" class="vue-select" v-model="analyzeLevel.analyze_level_1"  @change="handleAnalyzeParamChange('both')" :options="groupByOptions"></select2>
                        </div>
                        <div class="col max-w-160" v-if="getStatusFor(analyzeLevel.analyze_level_1) != null">
                            <button v-if="getStatusFor(analyzeLevel.analyze_level_1) == 'not_exists'" @click="criteriumButtonClicked(analyzeLevel.analyze_level_1, getStatusFor(analyzeLevel.analyze_level_1) )" class="btn btn-danger">
                                {{ __('define_criterion') }}</button>
                            <button v-if="getStatusFor(analyzeLevel.analyze_level_1) == 'not_complete'" @click="criteriumButtonClicked(analyzeLevel.analyze_level_1, getStatusFor(analyzeLevel.analyze_level_1) )" class=" btn btn-danger">
                                {{ __('fill_criterion') }}</button>
                            <button v-if="getStatusFor(analyzeLevel.analyze_level_1) == 'ready'" @click="criteriumButtonClicked(analyzeLevel.analyze_level_1, getStatusFor(analyzeLevel.analyze_level_1) )" class="btn btn-white">
                                {{ __('edit_criterion') }}</button>
                        </div>
                        <div class="col-3" v-if="(analyzeLevel.analyze_level_2 == null || analyzeLevel.analyze_level_2 == 0) && getStatusFor(analyzeLevel.analyze_level_1) == 'ready'">
                            <button class="btn btn-primary" @click="saveCriterias()">{{ __('save_settings') }}</button>
                        </div>
                    </div>
                    <div class="row mt-2" v-if="analyzeLevel.analyze_level_1 && analyzeLevel.analyze_level_1 != 0">
                        <div class="col-2">
                          {{__('divide_into_subgroups_by')}}
                        </div>
                        <div class="col-2">
                            <select2 style="width: 90%" class="vue-select" v-model="analyzeLevel.analyze_level_2" :options="groupByOptions" @change="handleAnalyzeParamChange('last')" :settings="levelTwoSettings"></select2>
                        </div>
                        <div class="col max-w-160" v-if="getStatusFor(analyzeLevel.analyze_level_2) != null">
                            <button v-if="getStatusFor(analyzeLevel.analyze_level_2) == 'not_exists'" @click="criteriumButtonClicked(analyzeLevel.analyze_level_2, getStatusFor(analyzeLevel.analyze_level_2) )" class="btn btn-danger">
                                {{ __('define_criterion') }}</button>
                            <button v-if="getStatusFor(analyzeLevel.analyze_level_2) == 'not_complete'" @click="criteriumButtonClicked(analyzeLevel.analyze_level_2, getStatusFor(analyzeLevel.analyze_level_2) )" class="btn btn-danger">
                                {{ __('fill_criterion') }}</button>
                            <button v-if="getStatusFor(analyzeLevel.analyze_level_2) == 'ready'" @click="criteriumButtonClicked(analyzeLevel.analyze_level_2, getStatusFor(analyzeLevel.analyze_level_2) )" class="btn btn-white">
                                {{ __('edit_criterion') }}</button>
                        </div>
                        <div class="col-3" v-if="(analyzeLevel.analyze_level_3 == null || analyzeLevel.analyze_level_3 == 0) && getStatusFor(analyzeLevel.analyze_level_2) == 'ready'">
                            <button class="btn btn-primary" @click="saveCriterias()">{{ __('save_settings') }}</button>
                        </div>
                    </div>
                    <div class="row mt-2" v-if="analyzeLevel.analyze_level_2 && analyzeLevel.analyze_level_2 != 0">
                        <div class="col-2">
                          {{__('divide_into_subgroups_by')}}
                        </div>
                        <div class="col-2">
                            <select2 style="width: 90%" class="vue-select" v-model="analyzeLevel.analyze_level_3" @change="resetVisibilitySession()" :options="groupByOptions" :settings="levelThreeSettings"></select2>
                        </div>
                        <div class="col max-w-160" v-if="getStatusFor(analyzeLevel.analyze_level_3) != null">
                            <button v-if="getStatusFor(analyzeLevel.analyze_level_3) == 'not_exists'" @click="criteriumButtonClicked(analyzeLevel.analyze_level_3, getStatusFor(analyzeLevel.analyze_level_3) )" class="btn btn-danger">
                                {{ __('define_criterion') }}</button>
                            <button v-if="getStatusFor(analyzeLevel.analyze_level_3) == 'not_complete'" @click="criteriumButtonClicked(analyzeLevel.analyze_level_3, getStatusFor(analyzeLevel.analyze_level_3) )" class="btn btn-danger">
                                {{ __('fill_criterion') }}</button>
                            <button v-if="getStatusFor(analyzeLevel.analyze_level_3) == 'ready'" @click="criteriumButtonClicked(analyzeLevel.analyze_level_3, getStatusFor(analyzeLevel.analyze_level_3) )"  class="btn btn-white">
                                {{ __('edit_criterion') }}</button>
                        </div>
                        <div class="col-3" v-if="getStatusFor(analyzeLevel.analyze_level_3) == 'ready' && getStatusFor(analyzeLevel.analyze_level_2) == 'ready' && getStatusFor(analyzeLevel.analyze_level_1) == 'ready'">
                            <button class="btn btn-primary" @click="saveCriterias()">{{ __('save_settings') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HelpModal from "../../components/help/HelpModal";
export default {
    name: "AnalyzeParameters",
    components:{HelpModal},
    props:{
        analyzeLevel:{
            type: Object
        },
        analyzeCriteriaStatus:{
            type: Object
        },
        analyzeType: {
            type: String
        },
    },
    methods:{
      handleAnalyzeParamChange(groups){
          if(groups == 'both'){
              this.analyzeLevel.analyze_level_2 = null;
              this.analyzeLevel.analyze_level_3 = null;
          }
          else
          {
              this.analyzeLevel.analyze_level_3 = null;
          }
          this.$emit('resetVisibility')
      },
        resetVisibilitySession()
        {
            this.$emit('resetVisibility')
        },
        getStatusFor(param){
          if(param == null){
              return null
          }
          return this.analyzeCriteriaStatus[param]
        },

        criteriumButtonClicked(criterium, status){
            this.$emit('criteriumButtonClicked',criterium, status);
        },
        saveCriterias(){
            this.$emit('saveCriterias');
        }

    },
    computed:{
        groupByOptions() {
            return [
                {text: '---', 'id': 0},
                {text: this.__('group_by_contractor_groups'), 'id': 'contractor'},
                {text: this.__('group_by_item_groups'), 'id': 'item'},
                {text: this.__('group_by_dates'), 'id': 'date'},
                {text: this.__('group_by_currency'), 'id': 'currency'},
            ]
        },
        levelTwoSettings(){
            return {
                templateResult: (option) => {
                    if (option.id == this.analyzeLevel.analyze_level_1) return null;

                    return option.text;
                },
            };
        },
        levelThreeSettings(){
            return {
                templateResult: (option) => {
                    if (option.id == this.analyzeLevel.analyze_level_1 ||option.id == this.analyzeLevel.analyze_level_2 ) return null;

                    return option.text;
                },
            };
        }
    }
}
</script>

<style scoped>

</style>
